module.exports = __webpack_public_path__ + "img/43_20.12efc07a.png";